
export enum NegotiationState {
  Unconfirmed= 'Unconfirmed',
  Open= 'Open',
  UnderSellerReview= 'UnderSellerReview',
  Closed= 'Closed',
  Unpaid= 'Unpaid',

}